export default "__VITE_ASSET__5d45827b__"